import { useEffect, useState } from "react";

/**
 * Re-render once a minute while `enabled`, and return the current minute (epoch minutes).
 *
 * For derived state that depends on the wall clock and must advance while the page sits
 * idle — e.g. a branch premise whose window closes at an explicit time settles at that
 * minute, not at the next local midnight. Off when there is nothing that needs it, since
 * every tick re-renders the caller.
 *
 * @param {boolean} [enabled]
 * @returns {number} Math.floor(Date.now() / 60000) as of the last tick
 */
export function useMinuteTick(enabled = true) {
  const [minute, setMinute] = useState(() => Math.floor(Date.now() / 60000));
  useEffect(() => {
    if (!enabled) return undefined;
    const id = setInterval(() => setMinute(Math.floor(Date.now() / 60000)), 60000);
    return () => clearInterval(id);
  }, [enabled]);
  return minute;
}
